'use client';

import { c as _c } from "react/compiler-runtime";
import { useCouponId, useCouponIndices } from '@svs/nova-poolbetting/core/nextjs/coupon';
import { CouponEvent } from '@svs/nova-poolbetting/ui/Coupon';
import { type PropsWithChildren, type ReactNode } from 'react';

/**
 * Component to wrap coupon event with additional properties.
 *
 * @param root0 props
 * @param root0.children children to be wrapped
 * @returns ReactNode with wrapped children
 */
export function CouponEventWrapper(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [couponId] = useCouponId();
  let t1;
  if ($[0] !== couponId) {
    t1 = {
      couponId
    };
    $[0] = couponId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const couponIndices = useCouponIndices(t1);
  const t2 = couponIndices.length > 1;
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <CouponEvent hasMultipleCoupons={t2}>{children}</CouponEvent>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}